import React from "react";
import {css, Theme} from "@emotion/react";

import {IRange} from "@pg-design/inputs-module";
import {head} from "@pg-mono/nodash";
import {OfferType} from "@pg-rp/common-types";

import {getAreaFilterLabelText} from "../../real_estate/utils/filter_labels";
import {floorOptions, floorOptionsForHouse} from "../components/FloorChoicesSwitch";

export const getAreaFilterLabel = (value: IRange<string>, defaultLabel: string) => {
    const {label, text} = getAreaFilterLabelText(value, defaultLabel);

    if (text) {
        return (
            <React.Fragment>
                {label}
                <br />
                <span css={subLabel}>
                    {text}&nbsp;
                    <span className="nowrap">
                        m<sup>2</sup>
                    </span>
                </span>
            </React.Fragment>
        );
    }

    return label;
};

export const getFloorChoiceLabel = (value?: number[], offerType?: OfferType) => {
    const options = offerType === OfferType.HOUSE ? floorOptionsForHouse : floorOptions;
    const floorChoiceVerbose = value && options.map((floor) => floor.value === head(value) && floor.label);

    if (value && value.length > 1) {
        return (
            <React.Fragment>
                Piętra <br />
                <span css={subLabel}>+{value.length}</span>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            Piętra <br />
            <span css={subLabel}>{floorChoiceVerbose}</span>
        </React.Fragment>
    );
};

const subLabel = (theme: Theme) => css`
    font-size: ${theme.globals.text.root};
    color: ${theme.colors.gray[700]};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {IRange} from "@pg-design/inputs-module";
import {head} from "@pg-mono/nodash";
import {OfferType} from "@pg-rp/common-types";

import {getAreaFilterLabelText} from "../../real_estate/utils/filter_labels";
import {floorOptions, floorOptionsForHouse} from "../components/FloorChoicesSwitch";

export const getAreaFilterLabel = (value: IRange<string>, defaultLabel: string) => {
    const {label, text} = getAreaFilterLabelText(value, defaultLabel);

    if (text) {
        return (
            <React.Fragment>
                {label}
                <br />
                <span css={subLabel}>
                    {text}&nbsp;
                    <span className="nowrap">
                        m<sup>2</sup>
                    </span>
                </span>
            </React.Fragment>
        );
    }

    return label;
};

export const getFloorChoiceLabel = (value?: number[], offerType?: OfferType) => {
    const options = offerType === OfferType.HOUSE ? floorOptionsForHouse : floorOptions;
    const floorChoiceVerbose = value && options.map((floor) => floor.value === head(value) && floor.label);

    if (value && value.length > 1) {
        return (
            <React.Fragment>
                Piętra <br />
                <span css={subLabel}>+{value.length}</span>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            Piętra <br />
            <span css={subLabel}>{floorChoiceVerbose}</span>
        </React.Fragment>
    );
};

const subLabel = (theme: Theme) => css`
    font-size: ${theme.globals.text.root};
    color: ${theme.colors.gray[700]};
`;
